export default __webpack_public_path__ + "static/media/janis-joplin.41b6bdc2.jpg";